(() => {

    class FloatingAtc extends HTMLElement {

        constructor() {
            super();

            this.link = this.getAttribute('data-link');
            this.init();
        }

        init() {
            this.setStyle();
            this.events();
        }

        setStyle() {
            if (this.isTouchDevice()) {
                if (this.classList.contains('hidden')){
                    this.classList.add('hidden')
                }
            }
        }

        isTouchDevice() {
            return ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
        }

        events() {
            this.addEventListener('click', this.handleClick.bind(this), false);

            if (!this.isTouchDevice()) {
                this.getContainer().addEventListener('mouseover', this.show.bind(this));
                this.getContainer().addEventListener('mouseleave', this.hide.bind(this));
            }
        }

        handleClick(event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            this.addToCart(event);
        }

        addToCart(evt) {
            return new Promise((resolve, reject) => {
                this.setDisabled();
                this.setLoading();
                return this.getProduct().then(product => {

                    let selected = this.getSelectedVariant();
                    let variants = [];
                    if (evt.target.classList.contains('sizes')){
                        let cusSwatch = evt.target.parentElement.parentElement.parentElement.querySelector('.cus_swatch.selected')
                        let cusSwatchTitle = cusSwatch.getAttribute('title')
                        let clickedSize = evt.target.getAttribute('data-size')
                        let sizeIndex = parseInt(evt.target.getAttribute('data-size-index'))
                        let clickedVariantData = JSON.parse(evt.target.getAttribute('data-variants'))
                        let variantByColor = clickedVariantData.filter(variant => {return variant[1] === cusSwatchTitle})
                        let currentVariant = variantByColor.filter(variant => {
                            return variant[sizeIndex + 1] === clickedSize
                        })
                        variants = product.variants.filter(variant => {
                            return variant.id === currentVariant[0][0]
                        })
                    } else {
                        if (selected) {
                            variants = product.variants.filter((variant) => {
                                return variant.title.toString().toLowerCase().includes(selected.toString().toLowerCase());
                            });
                        } else {
                            variants = product.variants;
                        }    
                    }

                    

                    return this.variantAtcRetry(variants).then((product) => {
                        this.showDrawer();
                        this.unsetDisabled();
                        return resolve(product);
                    }).catch(err => {
                        this.setSoldOut();
                        this.setDisabled();
                        return reject(err);
                    }).finally(() => {
                        setTimeout(() => {
                            this.unsetLoading();
                        }, 1000);
                    });

                });
            });
        }

        variantAtcRetry(variants, currentIndex) {
            return new Promise((resolve, reject) => {

                if (currentIndex > (variants.length - 1)) {
                    return reject(true);
                }
                if (typeof currentIndex === 'undefined') {
                    currentIndex = 0;
                }

                let params = { id: variants[currentIndex].id, quantity: 1 };
                return this.sendAtc(params).then((item) => {
                    return resolve(item);
                }).catch(() => {
                    return this.variantAtcRetry(variants, currentIndex + 1).then((item) => {
                        return resolve(item);
                    }).catch(err => {
                        return reject(err);
                    });
                })
            });
        }

        sendAtc(params) {
            return new Promise((resolve, reject) => {
                return fetch(`${window.Shopify.routes.root}cart/add.js`, {
                    body: JSON.stringify(params),
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
                    },
                    method: 'POST'
                }).then(function (response) {
                    if (response.ok) {
                        return response.json();
                    }
                    return reject(response.status);
                }).then(function (json) {
                    return resolve(json);
                }).catch(function (err) {
                    return reject(err);
                })
            });
        }

        getContainer() {
            return this.parentNode.parentNode.parentNode;
        }

        getSelectedVariant() {
            let container = this.getContainer();
            let list = container.querySelectorAll('.swatches_collection label.cus_swatch');

            if (list.length) {
                let selected = [...list].find((el) => {
                    return el.classList.contains('selected');
                });

                if (selected) {
                    return selected.getAttribute('title');
                }
            }

            return false;
        }

        getProduct() {
            return new Promise((resolve, reject) => {
                return fetch(this.link, {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                }).then(response => response.json()).then(({ product }) => {
                    return resolve(product);
                }).catch(err => {
                    return reject(err);
                })
            });
        }

        setLoading() {
            this.classList.add('loading');
            this.style.setProperty('display', 'block', 'important');

            let spinner = this.querySelector('.loading-overlay__spinner');
            if (spinner) {
                spinner.style.width = '';
            }

            if (!this.isTouchDevice()) {
                let span = this.querySelector('span');
                if (span) {
                    span.style.color = '';
                }
            } else {
                let span = this.querySelector('span');
                if (span) {
                    span.style.display = 'none';
                }
                this.style.borderBottom = '';
            }
        }

        unsetLoading() {
            this.classList.remove('loading');
            this.style.display = '';

            let spinner = this.querySelector('.loading-overlay__spinner');
            if (spinner) {
                spinner.style.width = 'auto';
            }

            if (!this.isTouchDevice()) {
                let span = this.querySelector('span');
                if (span) {
                    span.style.color = '#fff';
                }
            } else {
                let span = this.querySelector('span');
                if (span) {
                    span.style.display = '';
                }
                this.style.borderBottom = '1px solid rgb(0, 0, 0)';
            }
        }

        setDisabled() {
            this.disabled = true;
            this.setAttribute('aria-disabled', true);
        }

        unsetDisabled() {
            this.disabled = false;
            this.removeAttribute('aria-disabled');
        }

        setSoldOut() {
            let span = this.querySelector('span');
            if (span) {
                span.innerHTML = 'SOLD OUT';
                setTimeout(() => {
                    span.innerHTML = 'ADD TO CART';
                    this.unsetDisabled();
                }, 3000);
            }
        }

        showDrawer() {
            document.dispatchEvent(new CustomEvent('drawer:open:refresh'));
        }

        hide() {
            this.classList.add('hidden');
        }

        show() {
            this.classList.remove('hidden');
        }
    }

    if (!window.customElements.get('floating-atc')) {
        window.customElements.define('floating-atc', FloatingAtc)
    }

    const App = () => {
        let cards = document.querySelectorAll('#MainContent .card-wrapper.product-card-wrapper > .card > a');
        let productCards = [...cards].filter(element => {
            if (element.href && !element.hasAttribute('data-floating-atc')) {
                if (element.href.toString().includes('/products/')) {
                    return true;
                }
            }

            return false;
        });

        productCards.forEach(element => {
            element.style.position = 'relative';
            element.style.textDecoration = 'none';
            element.setAttribute('data-floating-atc', '');
            let button = `
                <div class="floating-atc-wrapper" style="position: absolute; bottom: 10px; width: 100%; display: flex; justify-content: center;">
                    <floating-atc data-link="${element.href}" class="button button--primary hidden">
                        <span style="color: #fff;">ADD TO CART</span>
                        <div class="loading-overlay__spinner" style="width: auto;">
                          <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                          </svg>
                        </div>
                    </floating-atc>
                </div>
            `;
            let multiFloatingAtc = ''
            if (element.parentElement.querySelector('.selected.cus_swatch')){
                let cusSwatch = element.parentElement.querySelector('.selected.cus_swatch')
                let variantData = JSON.parse(cusSwatch.getAttribute('variant-data'))
                let options = JSON.parse(cusSwatch.getAttribute('data-options'))
                if (options.length > 1){
                    if (options.includes('Size') || options.includes('size')){
                        let sizeIndex = options.findIndex(option => option.toLowerCase() === "size");
                        let dataOptionValues = JSON.parse(cusSwatch.getAttribute('data-option-values'))
                        let dataSizes = dataOptionValues[sizeIndex]
                        if (dataSizes.length > 1){
                            dataSizes.forEach(size => {
                                let sizeVariants = variantData.filter(variant => variant[sizeIndex + 1] === size)
                                multiFloatingAtc = multiFloatingAtc + `<floating-atc data-link="${element.href}" class="button sizes button--primary hidden" data-variants='${JSON.stringify(sizeVariants)}' data-size="${size}" data-size-index="${sizeIndex}">
                               <span style="color: #fff;">${size}</span>
                               <div class="loading-overlay__spinner" style="width: auto;">
                                <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                  <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                                </svg>
                              </div></floating-atc>`
                            })
                            button = `<div class="floating-atc-wrapper" style="position: absolute; bottom: 10px; width: 100%; display: flex; justify-content: center;">${multiFloatingAtc}</div>`
                        }

                    }
                }

            }
            element.insertAdjacentHTML(
                'beforeend',
                button
            );
        });
    };

    const checkifTouchDevice = () => {
        return ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
    }

    const addProductCardListener = () => {
        if (checkifTouchDevice()){
            let cardLinks = document.querySelectorAll('.floating-atc-wrapper')

            cardLinks.forEach(item => {
                let cardLink = item.parentElement
                cardLink.addEventListener('click', function(evt){
                    evt.preventDefault()
                    if (!cardLink.querySelector('floating-atc').classList.contains('hidden')){
                        window.location.href = cardLink.getAttribute('href')
                    }
                    document.querySelectorAll('floating-atc').forEach(item => {
                        if (!item.classList.contains('hidden')){
                            item.classList.add('hidden')
                        }
                    })
                    let floatingAtc = this.querySelectorAll('floating-atc')
                    floatingAtc.forEach(item =>{
                        item.classList.remove('hidden')
                    })
                })
            })
        }
    }

    document.addEventListener('DOMContentLoaded', () => {
        if (window?.floatingatc) {
            App();
            addProductCardListener()
        }
    });

    document.addEventListener('filter:products:updated', () => {
        if (window?.floatingatc) {
            App();
            addProductCardListener()
        }
    });

    

})();